<template>
  <form class="form-inline float-left">
    <div class="input-group" v-if="isAdmin || isPrinter">
      <div class="input-group-prepend">
        <button class="btn btn-primary btn-sm" type="button" @click="recoverOrder">恢复删除订单</button>
      </div>
      <input type="text" class="form-control" placeholder="请输入外部订单号" v-model="companyOrderNo" @keydown.enter.prevent="recoverOrder">
    </div>
  </form>
</template>
 

<script>
import RoleMixin from '@/mixins/role'
import {showFailedAlert, showSuccessAlert} from '@/utils/alert'

function recoverOrder () {
  this.companyOrderNo = this.companyOrderNo.trim()
  if (!this.companyOrderNo) {
    showFailedAlert('请输入订单号')
    return
  }

  let go = confirm('确认恢复这个订单吗， 请尽量避免此操作')
  if (!go) {
    return
  }
  this.$http.post('/api/orders/recover', {
    'company_order_no': this.companyOrderNo
  }).then(response => {
    if (response.data.success) {
      showSuccessAlert('成功')
      this.$router.push({
        query: {
          company_order_no: this.companyOrderNo
        }
      })
    }
  })
}

export default {
  name: 'orders-recover',
  mixins: [RoleMixin],
  data () {
    return {
      'companyOrderNo': ''
    }
  },
  methods: {
    recoverOrder
  }
}
</script>
